var formatters = {
    phoneFormatter(input) {
        // Strip all characters from the input except digits
        input = input.replace(/\D/g, '');

        // Trim the remaining input to ten characters, to preserve phone number format
        input = input.substring(0, 12);

        // Based upon the length of the string, we add formatting as necessary
        var size = input.length;
        if (size < 4) {
            input = '(' + input;
        } else if (size < 7) {
            input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6);
        } else if (size < 11) {
            input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6) + '-' + input.substring(6, 10);
        } else {
            input =
                '+' +
                input.substring(0, input.length - 10) +
                ' (' +
                input.substr(-10, 3) +
                ') ' +
                input.substr(-7, 3) +
                '-' +
                input.substr(-4, 4);
        }
        return input;
    },
    numberFormatter(input) {
        input = input.replace(/\D/g, '');
        return input;
    },
    currencyFormatter(input) {
        return `${input}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    currencyParser(input) {
        return input.replace(/\$\s?|(,*)/g, '');
    },
    titleCaseFormatter(input) {
        return input
            .split(' ')
            .map(function (word) {
                return word.charAt(0).toUpperCase() + word.slice(1);
            })
            .join(' ');
    },
};

export default formatters;
